import React from 'react';
import { BasePortalSection } from '../../../shared/components/portal-base/BasePortalSection';
import type { AdminPortalSectionProps } from '../types/admin';
import type { BasePortalConfig } from '../../../shared/types/portal-base';
import AdminLoginSection from './sections/AdminLoginSection';
import AdminResetPasswordSection from './sections/AdminResetPasswordSection';
import AdminDownloadGuideSection from './sections/AdminDownloadGuideSection';

// SVG Icons for the admin sidebar buttons
const UserIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
  </svg>
);

const KeyIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
  </svg>
);

const DocumentIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
  </svg>
);

const adminPortalConfig: BasePortalConfig = {
  theme: 'admin',
  sidebarButtons: [
    { id: 'login', label: 'Login', icon: UserIcon, section: 'login' },
    { id: 'forgot', label: 'Forgot Password?', icon: KeyIcon, section: 'reset-password' },
    { id: 'download', label: 'Download User Guide', icon: DocumentIcon, section: 'download-guide' }
  ],
  sections: [
    { id: 'login', component: AdminLoginSection },
    { id: 'reset-password', component: AdminResetPasswordSection },
    { id: 'download-guide', component: AdminDownloadGuideSection }
  ]
};

export const AdminPortalSection: React.FC<AdminPortalSectionProps> = ({ config, ...otherProps }) => {
  return <BasePortalSection config={adminPortalConfig} {...otherProps} />;
};

export default AdminPortalSection;